// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { objDefineProps } from "@nevware21/ts-utils";
import { _DYN_CONFIG, _DYN_HOST } from "../../__DynamicConstants";
import { setProtoTypeName } from "../../utils/HelperFuncs";
import { _createTraceApi } from "./trace/traceApi";
import { _createTracerProvider } from "./trace/tracerProvider";
/*#__NO_SIDE_EFFECTS__*/
export function createOTelApi(otelApiCtx) {
    var _traceApi;
    var otelApi = setProtoTypeName(objDefineProps(_createTracerProvider(otelApiCtx[_DYN_HOST /* @min:%2ehost */]), {
        cfg: { g: function () { return otelApiCtx.host[_DYN_CONFIG /* @min:%2econfig */]; } },
        trace: { g: function () { return _traceApi.v; } },
        host: { g: function () { return otelApiCtx[_DYN_HOST /* @min:%2ehost */]; } }
    }), "OTelApi");
    _traceApi = _createTraceApi(otelApi);
    return otelApi;
}
//# sourceMappingURL=OTelApi.js.map